import { Component, OnInit, Input, forwardRef, ViewEncapsulation } from '@angular/core';
import { FnInputValueAccessor } from '../../core/model/fn-input.value.accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FnRateItem } from './fn-rating.model';

@Component({
    selector: 'fn-rating',
    templateUrl: 'fn-rating.component.html',
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FnRatingComponent),
            multi: true
        }
    ],
})

export class FnRatingComponent extends FnInputValueAccessor<any> implements OnInit {

    @Input() starCount = 5;
    @Input() ratingName: string;
    itemArray: FnRateItem[] = [];
    @Input() valueCount = 0;

    ngOnInit() {

        this.value = this.valueCount !== 0 ? this.valueCount : 0;
        this.createStar();

    }

    createStar() {
        for (let i = 1; i <= this.starCount; i++) {
            if (this.value && (this.value >= 1 && this.value <= this.starCount)) {
                if (i <= this.value) {
                    this.itemArray.push({ id: i, name: i + this.ratingName, isSelected: true });
                } else {
                    this.itemArray.push({ id: i, name: i + this.ratingName, isSelected: false });
                }
            } else {
                this.itemArray.push({ id: i, name: i + this.ratingName, isSelected: false });
            }
        }
    }


    onLabelClick(item: any) {
        if (item != null || item !== undefined) {
            for (let i = 0; i < this.itemArray.length; i++) {
                // if star is not checked
                if (!item.isSelected) {
                    if (i < item.id) {
                        this.itemArray[i].isSelected = true;
                    }
                    if (this.itemArray[i].id > item.id) {
                        this.itemArray[i].isSelected = false;
                    }
                } else {
                    // if star is checked
                    if (item.id === this.itemArray[i].id) {
                        if (this.itemArray.length !== i + 1 && this.itemArray[i + 1].isSelected) {
                            for (let index = i + 1; index < this.itemArray.length; index++) {
                                this.itemArray[index].isSelected = false;
                            }
                            break;
                        }
                        this.itemArray[i].isSelected = false;
                    }

                }
            }
            this.value = 0;
            // tslint:disable-next-line: prefer-for-of
            for (let j = 0; j < this.itemArray.length; j++) {
                if (this.itemArray[j].isSelected) {
                    this.value = this.value + 1;
                }
            }
        }
    }
}